/* eslint-disable max-len */
/* eslint-disable react/react-in-jsx-scope */
import {colors} from '../theme/colors';

export const Icon = ({name, height, color}) => {
  switch (name) {
    case 'star':
      return (
        <svg xmlns="http://www.w3.org/2000/svg" height={height || '1rem'} viewBox="0 0 20 20" fill={color || colors.star}>
          <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1
                1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1
                1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54
                1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8
                2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1
                1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1
                1 0 00.951-.69l1.07-3.292z" />
        </svg>
      );
    case 'date':
      return (
        <svg height={height || '16'} viewBox="0 0 17 19" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M5 11.25C4.75208 11.25 4.54413 11.166 4.37613
              10.998C4.20871 10.8306 4.125 10.6229 4.125 10.375C4.125
              10.1271 4.20871 9.91912 4.37613 9.75112C4.54413 9.58371
              4.75208 9.5 5 9.5C5.24792 9.5 5.45588 9.58371 5.62388
              9.75112C5.79129 9.91912 5.875 10.1271 5.875 10.375C5.875
              10.6229 5.79129 10.8306 5.62388 10.998C5.45588 11.166
              5.24792 11.25 5 11.25ZM8.5 11.25C8.25208 11.25 8.04442
              11.166 7.877 10.998C7.709 10.8306 7.625 10.6229 7.625
              10.375C7.625 10.1271 7.709 9.91912 7.877 9.75112C8.04442
              9.58371 8.25208 9.5 8.5 9.5C8.74792 9.5 8.95588 9.58371
              9.12388 9.75112C9.29129 9.91912 9.375 10.1271 9.375
              10.375C9.375 10.6229 9.29129 10.8306 9.12388 10.998C8.95588
              11.166 8.74792 11.25 8.5 11.25ZM12 11.25C11.7521 11.25
              11.5444 11.166 11.377 10.998C11.209 10.8306 11.125 10.6229
              11.125 10.375C11.125 10.1271 11.209 9.91912 11.377
              9.75112C11.5444 9.58371 11.7521 9.5 12 9.5C12.2479
              9.5 12.4556 9.58371 12.623 9.75112C12.791 9.91912 12.875
              10.1271 12.875 10.375C12.875 10.6229 12.791 10.8306 12.623
              10.998C12.4556 11.166 12.2479 11.25 12 11.25ZM2.375
              18.25C1.89375 18.25 1.48162 18.0788 1.13862 17.7364C0.796208
              17.3934 0.625 16.9813 0.625 16.5V4.25C0.625 3.76875 0.796208
              3.35692 1.13862 3.0145C1.48162 2.6715 1.89375 2.5 2.375
              2.5H3.25V1.60312C3.25 1.35521 3.33371 1.15104 3.50113
              0.990625C3.66913 0.830208 3.87708 0.75 4.125 0.75C4.37292
              0.75 4.58087 0.833708 4.74887 1.00112C4.91629 1.16912 5
              1.37708 5 1.625V2.5H12V1.60312C12 1.35521 12.084 1.15104
              12.252 0.990625C12.4194 0.830208 12.6271 0.75 12.875 0.75C13.1229
              0.75 13.3306 0.833708 13.498 1.00112C13.666 1.16912 13.75 1.37708
              13.75 1.625V2.5H14.625C15.1063 2.5 15.5184 2.6715 15.8614
              3.0145C16.2038 3.35692 16.375 3.76875 16.375 4.25V16.5C16.375
              16.9813 16.2038 17.3934 15.8614 17.7364C15.5184 18.0788 15.1063
              18.25 14.625 18.25H2.375ZM2.375 16.5H14.625V7.75H2.375V16.5Z"
          fill={color || colors.gray} fillOpacity="0.45"/>
        </svg>
      );
    case 'arrow-right':
      return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" height={height || '1rem'} fill={color || colors.primary}>
          <path fillRule="evenodd" d="M16.72 7.72a.75.75 0 011.06
              0l3.75 3.75a.75.75 0 010 1.06l-3.75 3.75a.75.75 0
              11-1.06-1.06l2.47-2.47H3a.75.75 0 010-1.5h16.19l-2.47-2.47a.75.75
              0 010-1.06z" clipRule="evenodd" />
        </svg>
      );
    case 'facebook':
      return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" height={height || '1.8rem'} fill={color || colors.primary}>
          <path d="M400 32H48A48 48 0 0 0 0 80v352a48 48 0 0 0 48
              48h137.25V327.69h-63V256h63v-54.64c0-62.15 37-96.48
              93.67-96.48 27.14 0 55.52 4.84 55.52 4.84v61h-31.27c-30.81
              0-40.42 19.12-40.42 38.73V256h68.78l-11
              71.69h-57.78V480H400a48 48 0 0 0 48-48V80a48 48
              0 0 0-48-48z"/></svg>
      );
    case 'instagram':
      return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" height={height || '1.8rem'} fill={color || colors.primary}>
          <path d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9
          114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0
          189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7
          74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0
          14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8
          26.8-26.8 26.8 12 26.8 26.8zm76.1
          27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9
          0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1
          37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58
          34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7
          67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9
          2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8
          19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1
          9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7
          9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7
          99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7
          22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7
          102.7-9 132.1z"/></svg>
      );
    case 'twitter':
      return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" height={height || '1.8rem'} fill={color || colors.primary}>
          <path d="M459.37 151.716c.325 4.548.325 9.097.325 13.645
          0 138.72-105.583 298.558-298.558 298.558-59.452
          0-114.68-17.219-161.137-47.106 8.447.974 16.568 1.299 25.34 1.299 49.055
          0 94.213-16.568 130.274-44.832-46.132-.975-84.792-31.188-98.112-72.772
          6.498.974 12.995 1.624 19.818 1.624 9.421 0 18.843-1.3
          27.614-3.573-48.081-9.747-84.143-51.98-84.143-102.985v-1.299c13.969
          7.797 30.214 12.67 47.431 13.319-28.264-18.843-46.781-51.005-46.781-87.391
          0-19.492 5.197-37.36 14.294-52.954 51.655 63.675 129.3 105.258 216.365
          109.807-1.624-7.797-2.599-15.918-2.599-24.04 0-57.828 46.782-104.934
          104.934-104.934 30.213 0 57.502 12.67 76.67 33.137 23.715-4.548
          46.456-13.32 66.599-25.34-7.798 24.366-24.366 44.833-46.132
          57.827 21.117-2.273 41.584-8.122 60.426-16.243-14.292
          20.791-32.161 39.308-52.628 54.253z"/></svg>
      );
    case 'bbc':
      return (
        <svg xlink="http://www.w3.org/1999/xlink" xmlns="http://www.w3.org/2000/svg" height={height || '1.8rem'} fill={color || colors.primary} viewBox="0 0 32 32">
          <path id="link" d="M28,13.5v5A4.5,4.5,0,0,1,23.5,23h-7A4.5,4.5,0,0,1,12,18.5V15a1,1,0,0,1,1-1h1a1,1,0,0,1,1,1v3.5A1.5,1.5,0,0,0,16.5,20h7A1.5,1.5,0,0,0,25,18.5v-5A1.5,1.5,0,0,0,23.5,12H21.86035a.49994.49994,0,0,1-.4743-.34186l-.66669-2A.5.5,0,0,1,21.19373,9H23.5A4.5,4.5,0,0,1,28,13.5ZM10.614,20.34186A.49994.49994,0,0,0,10.13965,20H8.5A1.5,1.5,0,0,1,7,18.5v-5A1.5,1.5,0,0,1,8.5,12h7A1.5,1.5,0,0,1,17,13.5V17a1,1,0,0,0,1,1h1a1,1,0,0,0,1-1V13.5A4.5,4.5,0,0,0,15.5,9h-7A4.5,4.5,0,0,0,4,13.5v5A4.5,4.5,0,0,0,8.5,23h2.30627a.5.5,0,0,0,.47437-.65814Z"></path>
        </svg>
      );
    case 'justwatch':
      return (
        <svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" height={height || '1.5rem'} viewBox="0 0 28 27" version="1.1">
          <defs>
            <linearGradient x1="0%" y1="50%" x2="100%" y2="50%" id="linearGradient-1">
              <stop stopColor={color || colors.primaryLight}offset="0%"></stop>
              <stop stopColor={color || colors.primary} offset="100%"></stop>
            </linearGradient>
          </defs>
          <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g id="justwatch-small-black" fill="url(#linearGradient-1)" fillRule="nonzero">
              <path d="M0.367831,19.7015845 C0.368397832,19.62791 0.375046205,19.5780917
              0.375046205,19.5780917 C0.375046205,19.5780917
              0.423670408,15.4853053 0.382261409,14.4518798
              C0.340538706,13.4190742 1.26377116,13.9094399 1.26377116,13.9094399
              L6.44303308,16.5562366 C6.44303308,16.5562366 7.45567132,17.0366833
              6.42546562,17.5595954 C5.66504582,17.9461226 2.27013532,19.701768
              1.24902705,20.1874842 C0.465525063,20.5607587 0.369990246,20.0012268
              0.367831,19.7215301 L0.367831,19.7015844 L0.367831,19.7015845 Z
              M21.6178624,10.8066842 C21.6178624,10.8066842 21.5472788,9.96357761
              22.2703678,10.330267 C22.9943978,10.6972663 26.6023135,12.5266837
              26.6023135,12.5266837 C26.6023135,12.5266837 28.5987291,13.507725
              26.597608,14.5172832 C25.1824869,15.2311341 23.0232586,16.3219033
              22.2791515,16.6957219 C21.5347307,17.0695405 21.6122157,16.2639397
              21.6122157,16.2639397 L21.6178624,10.8066842 Z M15.4068256,20.3226297
              C14.3860312,20.8086558 14.5325312,19.7135472 14.5325312,19.7135472
              C14.5325312,19.7135472 14.5814691,15.6207609 14.5400601,14.5870255
              C14.4980237,13.5536 15.4215698,14.0448956 15.4215698,14.0448956
              L20.6002039,16.6913822 C20.6002039,16.6913822 21.6134695,17.171519
              20.5826364,17.695051 C19.8231578,18.0809582 16.4279338,19.8369136
              15.4068256,20.3226297 Z M8.33655361,23.8398104 C7.31544537,24.3258366
              7.46225909,23.229798 7.46225909,23.229798 C7.46225909,23.229798
              7.5108833,19.1370114 7.4694743,18.1038958 C7.4277516,17.0701603
              8.35067032,17.5614559 8.35067032,17.5614559 L13.5302458,20.2082527
              C13.5302458,20.2082527 14.542884,20.6883895 13.5123646,21.2119215
              C12.7522586,21.5975188 9.35734815,23.3534743 8.33655361,23.8398104
              Z M8.34439585,16.6755735 C7.3236013,17.1612897 7.47041503,16.066181
              7.47041503,16.066181 C7.47041503,16.066181 7.51903923,11.9733944
              7.47731653,10.9399689 C7.43590753,9.90654336 8.35882626,10.397529
              8.35882626,10.397529 L13.5384018,13.0443258 C13.5384018,13.0443258
              14.5513537,13.5244626 13.5205206,14.0476846 C12.7607283,14.4335919
              9.36550411,16.1895473 8.34439585,16.6755735 Z M15.4083947,12.9752037
              C14.3876003,13.4612298 14.534414,12.3661212 14.534414,12.3661212
              C14.534414,12.3661212 14.5830382,8.27302477 14.5413155,7.23959929
              C14.4995928,6.20648378 15.4228252,6.6971594 15.4228252,6.6971594
              L20.6020867,9.34426607 C20.6020867,9.34426607 21.6150385,9.82409289
              20.5842055,10.3473149 C19.8240995,10.7332221 16.4288755,12.4891776
              15.4083947,12.9752037 Z M1.25624218,13.115618 C0.235447697,13.6016441
              0.382261408,12.5059155 0.382261408,12.5059155 C0.382261408,12.5059155
              0.430885608,8.41312912 0.389162908,7.37970366 C0.347440207,6.34658815
              1.27067259,6.83726377 1.27067259,6.83726377 L6.44993409,9.4843704
              C6.44993409,9.4843704 7.46288596,9.96419722 6.43205293,10.4877292
              C5.6722606,10.8739464 2.27703666,12.6292819 1.25624218,13.115618
              Z M8.33718093,9.44314494 C7.31670011,9.92917109 7.46288642,8.83406242
              7.46288642,8.83406242 C7.46288642,8.83406242 7.51182432,4.74127589
              7.46978792,3.70754043 C7.42869262,2.67442489 8.35161134,3.16541049
              8.35161134,3.16541049 L13.5308731,5.81220724 C13.5308731,5.81220724
              14.543825,6.29203407 13.5133056,6.8152561 C12.7531995,7.20147331
              9.35797546,8.95742875 8.33718093,9.44314494 Z M0.380375732,21.2509757
              C0.378810659,20.7237241 0.912735781,20.9397702 0.912735781,20.9397702
              C0.912735781,20.9397702 6.19018721,23.6271725 6.78653954,23.9358983
              C7.38351927,24.2449341 6.78779436,24.5871362 6.78779436,24.5871362
              C6.78779436,24.5871362 4.65617202,25.645359 2.5869769,26.7032718
              C0.518095473,27.7618045 0.388849204,25.7154112 0.388849204,25.7154112
              L0.380375732,21.2509757 Z M0.40296577,5.75734324 L0.407671476,1.29259804
              C0.407671476,1.29259804 0.535349219,-0.753485212 2.60517169,0.302877719
              C4.67499416,1.35893068 6.80787124,2.41467368 6.80787124,2.41467368
              C6.80787124,2.41467368 7.40359614,2.75687576 6.80724383,3.06622148
              C6.21057782,3.3755672 0.936263604,6.06761886 0.936263604,6.06761886
              C0.936263604,6.06761886 0.402652204,6.28397488 0.40296577,5.75734324 Z"
              id="icon"></path>
            </g>
          </g>
        </svg>
      );

    default:
      return <></>;
  }
};
